"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupType = void 0;
/**
 * Comparison groups delimeters
 */
var GroupType;
(function (GroupType) {
    GroupType["AND"] = ";";
    GroupType["OR"] = ",";
})(GroupType = exports.GroupType || (exports.GroupType = {}));
//# sourceMappingURL=comparison-group.js.map